// A customer's country must be explicitly supplied, never inferred from the agent's timezone.
export const getActiveDialCode = () => '';
export const getActiveCountryCode = () => '';
